(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutBoundDetailTipsController', OutBoundDetailTipsController);

    OutBoundDetailTipsController.$inject = ['$scope','$timeout','$uibModalInstance','msgdata','flag'];

    function OutBoundDetailTipsController ($scope, $timeout,$uibModalInstance,msgdata,flag) {
        var vm = this;
        vm.amount = 0
        vm.lines = []
        vm.flag = flag
        vm.expressNumber = ''
        if(vm.flag){
            init()
        }
        function init(){
            msgdata.lines && msgdata.lines.forEach(function(item){
                console.log(item);
                if(item.num - item.outNum > 0){
                    // var _amount =
                    vm.amount += (item.num - item.outNum) * item.price
                    vm.lines.push(item)
                }
            })
            if(vm.lines.length){
                $timeout(function(){
                    var dom = document.getElementsByClassName('bg-center')
                    var dom1 = document.getElementsByClassName('modal-lg')
                    dom[0].style.width = '990px'
                    dom1[0].style.width = '990px'
                })
            }
        }
        $scope.cancelRecord = function(){
            $uibModalInstance.close();
        };
        $scope.save = function(){
            console.log(vm.flag,vm.expressNumber);
            $uibModalInstance.close({flag:vm.flag,expressNumber:vm.expressNumber});
        };

    }
})();
